export enum BonusSettlementType {
    Main = 'MAIN',
    Reclaim = 'RECLAMATION',
}

const translationObject: { [Key in BonusSettlementType]: string } = {
    [BonusSettlementType.Main]: 'app.bonusSettlement.type.mainSettlement',
    [BonusSettlementType.Reclaim]: 'app.bonusSettlement.type.reclaim',
};

export const getBonusSettlementTypeTranslationId = (type?: BonusSettlementType): string => {
    return type ? translationObject[type] : 'app.bonusSettlement.type.mainSettlement';
};
